import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import {ContextConsumer} from '../Context'

const styles = {
  switchLabel: {
    fontSize: '1rem',
  },
  darkTextLabel: {
    fontSize: '1rem',
    color: '#666',
  },
}

const Toggle = ({classes, checked, value, darkText, label}) => (
  <ContextConsumer>
    {context => {
      return (
        <FormControlLabel
          classes={{
            label: darkText ? classes.darkTextLabel : classes.switchLabel,
          }}
          control={
            <Switch
              checked={checked}
              onChange={context.handleChecked(value)}
              value={value}
              classes={{
                checked: classes.checked,
                bar: classes.bar,
              }}
            />
          }
          label={label}
        />
      )
    }}
  </ContextConsumer>
)

Toggle.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Toggle)



// WEBPACK FOOTER //
// ./src/components/Toggle.js